define([
  "globals",
  "jquery",
  "local-storage"],
function(globals, $, LocalStorage) {

  "use strict";

  var CartCount = function() {

    var localSt = new LocalStorage();
    var currentCartCount = 0;
    var newCartCount = 0;

    var add = function($cartObj) {
      currentCartCount = localSt.getFromLocalStorage("cart-count", 0);
      newCartCount = currentCartCount + 1;
      localSt.persist("cart-count", newCartCount);
      $cartObj.attr("data-cart-count", newCartCount);
    };

    var remove = function($cartObj) {
      currentCartCount = localSt.getFromLocalStorage("cart-count", 0);
      newCartCount = currentCartCount - 1;
      localSt.persist("cart-count", newCartCount);
      $cartObj.attr("data-cart-count", newCartCount);
    };

    var update = function(cartCount, $cartObj) {
      localSt.persist("cart-count", cartCount);
      $cartObj.attr("data-cart-count", cartCount);
    };

    return {
      addToCartCount: add,
      removeFromCartCount: remove,
      updateCartCount: update
    };

  };

  return CartCount;

});
